import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchDebts = createAsyncThunk("debts/fetch", async () => {
  const response = await API.get("/debts")
  return response.data
})

export const fetchDebt = createAsyncThunk(
  "debt/fetch",
  async (values: { debt_id: string }) => {
    const response = await API.get(`/debts/${values.debt_id}`)
    return response.data.debt
  },
)
